(function () {
    'use strict';

    angular
        .module('ipmApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('psych-intake', {
                abstract: true,
                parent: 'app',
                url: '/psych-intake',
                data: {
                    authorities: [],
                },
                views: {
                    'content@': {
                        templateUrl: 'app/psych-intake/psych-intake.html',
                        controller: 'PsychIntakeController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('psychIntake');
                        $translatePartialLoader.addPart('psychIntakeAgreements');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }],
                    psychIntake: ['PsychIntakeService', '$window', 'ipmConstants', function(PsychIntakeService, $window, constants) {
                        var id = $window.localStorage.getItem(constants.PSYCH_INTAKE_FORM_ID);
                        return PsychIntakeService.getPsychIntakeForm(id);
                    }]
                }
            }).state('psych-intake.workflow', {
                parent: 'psych-intake',
                url: '/workflow',
                data: {
                    authorities: [],
                    pageTitle: ''
                },
                views: {
                    'workflow-view@psych-intake': {
                        templateUrl: 'app/psych-intake/workflow/workflow.html',
                        controller: 'PsychIntakeWorkflowController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    dataWorkflow: ['$state', 'psychIntake', 'PsychIntakeService', function($state, psychIntake, PsychIntakeService) {
                        if(psychIntake.id) {
                            return PsychIntakeService.viewWorkflow(psychIntake.id);
                        } else {
                            return $state.go('home');
                        }
                    }]
                }
            }).state('psych-intake.agreements-workflow', {
                parent: 'psych-intake',
                url: '/agreements-workflow',
                data: {
                    authorities: [],
                    pageTitle: ''
                },
                views: {
                    'content@': {
                        templateUrl: 'app/psych-intake/agreements-workflow/agreements-workflow.html',
                        controller: 'PsychIntakeAgreementsWorkflowController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    dataWorkflow: ['$state', 'psychIntake', 'PsychIntakeService', function($state, psychIntake, PsychIntakeService) {
                        if(psychIntake.id) {
                            console.log('psych-intake.agreements-workflow', psychIntake.id);
                            return PsychIntakeService.viewWorkflow(psychIntake.id);
                        } else {
                            return $state.go('home');
                        }
                    }]
                }
            });
    }

})();
